import { Box } from '@chakra-ui/react';
import {
  getAppActiveStep,
  getAppType,
} from '../../redux/appBuilder/stepperDetails/selectors';
import { useAppSelector } from '../../redux/hooks';
import { HomeDashboard } from '../applications/components/dashboard.component';
import { NewAppDetails } from './components/app-details.component';
import { NewAppFinish } from './components/app-finish.component';
import { SelectProvider } from './components/select-provider.component';
import { VerifyApp } from './components/verify-app.component';
import RequestBuild from './components/requestBuild';
import BuildSelections from './components/buildSelections';
import ZkfetchFinlize from './components/zkfetchfinlize';
import { CreateBlueCheckApp } from './bluecheck-components/create-bluecheck-app.component';

export const NewApplicationScreen = () => {
  const activeStep = useAppSelector(getAppActiveStep);
  const appType = useAppSelector(getAppType);
  return (
    <>
      {appType === 'BC_APP' ? (
        <CreateBlueCheckApp />
      ) : (
        <Box display="flex" h="fit-content" justifyContent="center" width="100%">
          {activeStep === 0 && <HomeDashboard />}
          {activeStep === 1 && <NewAppDetails />}
          {activeStep === 2 && appType === 'ZK_FETCH' && <RequestBuild />}
          {activeStep === 2 && appType !== 'ZK_FETCH' && <SelectProvider />}
          {activeStep === 3 && appType === 'ZK_FETCH' && <BuildSelections />}
          {activeStep === 4 && <VerifyApp />}
          {activeStep === 5 && appType === 'ZK_FETCH' && <ZkfetchFinlize />}
          {activeStep === 5 && appType !== 'ZK_FETCH' && <NewAppFinish />}
        </Box>
      )}
    </>
  );
};
